// @flow
const handlers = {
  onChangeEmail: props => event => {
    props.setEmail(event.target.value)
  },
  onKeyPress: ({ submit }) => event => {
    if (event.charCode === 13) {
      submit()
    }
  }
}

export default handlers
